import { useParams } from "react-router-dom";
import { useRoot } from "../../../context/root";

export const useList = () => {
  const { dataList, isLoading, totalPages, currentPage, mapRefresh } = useRoot();
  const { geohash } = useParams();
  const onLastElementVisible = () => {
    const nextPage = currentPage + 1;
    if (nextPage < totalPages) {
      if (geohash) {
        mapRefresh({ page: nextPage, geohash });
      }
      else {
        mapRefresh({ page: nextPage });
      }
    }
  }

  const generatePseudorandomString = (length: number) => {
    const chars = '0123456789qwertyuioplkjhgfdsazxcvbnm';
    return Array.from(Array(length)).reduce((prev: string) => {
      return prev + chars.charAt(Math.floor(Math.random() * chars.length))
    }, '')
  }

  return {
    data: dataList,
    isLoading,
    onLastElementVisible,
    generatePseudorandomString,
  }
}
